package one.healthium.uscreen.di

import one.healthium.uscreen.data.AppUScreenRepository
import one.healthium.uscreen.domain.UScreenInteractor
import one.healthium.uscreen.domain.UScreenRepository
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val uscreenDataModule = module {
    singleOf(::AppUScreenRepository) bind UScreenRepository::class
    factoryOf(::UScreenInteractor)
}
